import { render, staticRenderFns } from "./PriorKnowledgeResults.vue?vue&type=template&id=6af57d8c&"
import script from "./PriorKnowledgeResults.vue?vue&type=script&lang=js&"
export * from "./PriorKnowledgeResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports